/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {theme, pxToEm, replacePXinStringWithEM, disable, pxToEmWithBaseline} from '@insticator/insticator-ui';



/* ++++++++++ --------------- LABEL ASSIGNMENT COLLECTION : STYLES --------------- ++++++++++ */
export default {
    labelassignmentcollection: {
        listStyleType: 'none',
        display: 'flex',
        flexWrap: 'wrap',
        maxHeight: pxToEm(100),
        overflow: 'auto',
        position: 'relative',

        '& .assignmentfieldinput': {
            flexGrow: 1,
            minWidth: pxToEm(70),
            '& .assignmentfieldinputfield': {
                width: '100%',
                height: pxToEmWithBaseline({ value: 26, fontSizeBaseline: 14 }),
                color: theme.color.supporting.dark.swatch,
                border: 'none',
                backgroundColor: 'transparent',
                // transition: 'all .1s linear 0s',
                '&.valid-false': {
                    background: theme.color.attention.medium.swatch,
                    transition: 'background-color 0.5s ease'
                },
                '&.valid-true': {
                    // background: theme.color.attention.medium.swatch,
                    transition: 'background-color 0.5s ease-out'
                },
                '&:focus': {
                    outline: 'none'
                }
            },

        }
    }
};
